import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ClientIdBusService {

  constructor() { }
  private selectedClientIdSubject = new Subject<string>();
  selectedClientId$ = this.selectedClientIdSubject.asObservable();

  announce(id: string) {
    this.selectedClientIdSubject.next(id);
  }
}
